import http from "@/shared/services/http";

export const listDebtPostOffice = (params: any) =>  http.get(`v1/debt-post-offices`,  { params });
export const allDebtPostOffice = (params: any) =>  http.get(`v1/debt-post-offices/all`,  { params });
export const receiptPostOffice = (data: any) =>  http.post(`v1/revenue-expenditures/post-office`, data);